import { useState } from "react";
import { FaPlus } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import CtaBanner from "../components/common/CtaBanner";
import { faqs } from "../data/content";

export function Accordion({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div>
      {items.map((f, i) => (
        <div className={`accordion-item ${open === i ? "open" : ""}`} key={i}>
          <button className="accordion-head" onClick={() => setOpen(open === i ? -1 : i)}>
            {f.q} <FaPlus />
          </button>
          <div className="accordion-body"><p>{f.a}</p></div>
        </div>
      ))}
    </div>
  );
}

export default function Faqs() {
  return (
    <>
      <PageHeader title="FAQs" crumbs={[{ label: "FAQs" }]} />
      <section className="section">
        <div className="container" style={{ maxWidth: 860 }}>
          <SectionTitle
            subtitle="FAQs"
            title="Frequently Asked <span>Questions</span>"
            text="Got questions? We've got answers. Here are the most common ones."
          />
          <Accordion items={faqs} />
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
